import React from 'react';

import R2Image from '@/components/ui/R2Image';

import type { TestGroup } from '../../types';
import { PlusMinusIcon } from './icons';

interface GroupedTestsListProps {
  testGroups: TestGroup[];
  openGroups: Set<number>;
  onToggleGroup: (index: number) => void;
  cardOpen: boolean;
}

export default function GroupedTestsList({
  testGroups,
  openGroups,
  onToggleGroup,
  cardOpen,
}: GroupedTestsListProps): React.ReactElement {
  return (
    <ul className="text-text-list font-regular space-y-1.5 text-base">
      {testGroups.map((group, gi) => {
        const isGroupOpen = openGroups.has(gi);
        const hasItems = (group.items?.length ?? 0) > 0;

        return (
          <li key={gi} className={gi >= 2 && !cardOpen ? 'hidden' : ''}>
            <div className="flex items-center gap-2">
              <R2Image
                path="/images/healthpackages/check-icon.svg"
                alt="check"
                width={20}
                height={20}
                className="shrink-0 object-contain"
              />
              <span className="flex-1 uppercase">{group.name}</span>
              {hasItems && (
                <button
                  type="button"
                  onClick={() => onToggleGroup(gi)}
                  aria-expanded={isGroupOpen}
                  aria-label={`${isGroupOpen ? 'Hide' : 'Show'} details for ${group.name}`}
                  className="border-theme-brand-blue flex size-5 shrink-0 cursor-pointer items-center justify-center rounded-full border"
                >
                  <PlusMinusIcon open={isGroupOpen} />
                </button>
              )}
            </div>
            {isGroupOpen && hasItems && (
              <ul className="text-text-muted-medium mt-1 ml-10 list-disc space-y-1 text-sm">
                {group.items.map((item, ii) => (
                  <li key={ii}>{item}</li>
                ))}
              </ul>
            )}
          </li>
        );
      })}
    </ul>
  );
}
